import {useContext} from "react";
import {BookingInfoContext} from "../context/BookingInfoContext";

export const useBookingInfoContext = () => useContext(BookingInfoContext)